import React, { useContext, useEffect, useRef, useState } from 'react';

import { RouteComponentProps } from 'react-router';

import {
  translateBareContentTemplate,
  convertContentTemplateToLegacy,
  populateContentTemplate,
} from '@go-shared/lib/contentTemplate';
import { translateVenueTemplate } from '@go-shared/lib/venueTemplate';
import {
  BareContentTemplate,
  FeedEditorElementType,
  BareContentTemplateLegacy,
} from '@go-shared/types/contentTemplate';
import {
  BareFeedTemplate,
  FeedArea,
  FeedEditorFont,
  FeedPage,
  FeedTemplate,
} from '@go-shared/types/feedTemplate';
import { InteractiveFeed, MenuBar, SailingDayHeader, TemplateLinkForm } from '../components';
import { getPropertyContentTemplates as getContentTemplates } from '../lib/api/contentTemplate';
import { populate as populateFeed } from '../lib/api/feedTemplate';
import { createTemplateFromSailingDay } from '../lib/api/itinerary';
import { extractTemplateStatus } from '../lib/itinerary';

import { BrandLogo } from '@go-client/components/UIkit/Brand/BrandLogo/BrandLogo';
import { RUNDOWN_DEFAULT_FONT_SIZE } from '@go-shared/lib/feed';
import { BareEvent, Event } from '@go-shared/types/event';
import { Plan, VenueDisposition } from '@go-shared/types/plan';
import { Property } from '@go-shared/types/property';
import {
  BareSimpleSailing,
  BareSimpleSailingDay,
  SailingDayBundle,
} from '@go-shared/types/sailing';
import {
  getPropertyEventTemplates,
  populate as populateEventTemplate,
} from '../lib/api/eventTemplate';
import { populate as populateGroupEvent } from '../lib/api/groupEvent';
import {
  getStaffTemplatesByPropertyId,
  populate as populateStaffTemplate,
} from '../lib/api/staffTemplate';
import {
  getVenueTemplatesByPropertyId,
  populate as populateVenueTemplate,
} from '../lib/api/venueTemplate';
import { eventToPartialEvent, populate as populateEvent } from '../lib/event';
import { isDayLocked } from '../lib/sailing';
import './FeedEditor.scss';

import { Dropdown, Popup, Tooltip } from '@spark-labs/avocado-ui';
import { FeedEditorSidebar } from '@go-client/components/FeedEditor/ContentSidebar/FeedEditorSidebar';
import { FeedEditorPages } from '@go-client/components/FeedEditor/Menu/FeedEditorMenu';
import { FeedEditorCtx, FeedEditorSettingsPanel } from '@go-client/context/FeedEdtitorContext';
import { createText } from '@go-client/lib/feedEditor';
import { BareVenueTemplate, VenueTemplate } from '@go-shared/types/venueTemplate';
import { ObjectId } from 'bson';

import {
  BubbleAccordion,
  BubbleButton,
  BubbleDrawer,
  BubbleOverlay,
} from '@go-client/components/BubbleUI';
import BubbleDrawerBasicContainer from '@go-client/components/BubbleUI/BubbleDrawerHeader';
import { ContentBlurbSettings } from '@go-client/components/FeedEditor/ContentSidebar/Blurbs/ContentBlurbs';
import { VenueRundownEditor } from '@go-client/components/FeedEditor/VenueRundown/VenueRundownEditor';
import { SailingDateWidget } from '@go-client/components/FeedEditor/Widgets/SailingDateWidget/SailingDateWidget';
import TemplateForm, { TemplateFormDataBase } from '@go-client/components/TemplateForm';
import { FragmentBlockSync } from '@go-client/components/TemplateLinkForm/TemplateLinkForm';
import { PropertyBanner } from '@go-client/components/UIkit/Property/PropertyBanner';
import { updateTags } from '@go-client/lib/api/property';
import {
  linkTemplateFragments,
  unlinkTemplateFragments,
} from '@go-client/lib/api/templateFragment';
import { getTranslations, getTranslationsByRefers } from '@go-client/lib/api/translation';
import { getErrorMessage } from '@go-shared/errors';
import { translateEventTemplate } from '@go-shared/lib/eventTemplate';
import { firstEl, lastEl, move, notUndefined } from '@go-shared/lib/functional';
import { getDayLocation } from '@go-shared/lib/sailing';
import { safeIdCompare, unsafeDeepCopy } from '@go-shared/lib/utils';
import { Language } from '@go-shared/types/info';
import { LinkFragment, StrategicLinkFragment } from '@go-shared/types/templateFragment';
import {
  ContentTemplateTranslation,
  EventTemplateTranslation,
  MealPeriodTranslation,
  VenueTemplateTranslation,
  CommonTextTranslation,
  VenueTypeTranslation,
  SegmentTranslation,
  LevelTranslation,
  AttributeTranslation,
  HighlightTranslation,
  DayThemeTranslation,
  ContentSegmentTranslation,
  ContentLevelTranslation,
  ContentAttributeTranslation,
} from '@go-shared/types/translation';
import { User } from '@go-shared/types/user';
import { VenueMealPeriodsEditor } from '@go-client/components/FeedEditor/VenueMealPeriods/VenueMealPeriodsEditor';
import { BareTemplate } from '@go-shared/types/template';
import { canEditFeed } from '@go-shared/lib/permissions';
import { resolveTemplateFeedPath } from '@go-client/routes';
import TemplateAssociations from '@go-client/components/TemplateAssociations';
import { populateDayTemplate } from '@go-client/lib/api/template';
import { ReplacedDict, TranslatedReplacedDict } from '@go-shared/types/mergedVars';
import { evaluateMergedVars } from '@go-shared/lib/mergedVars';
import { BareEventTemplate, EventTemplate } from '@go-shared/types/eventTemplate';
import { ItineraryWidget } from '@go-client/components/FeedEditor/Widgets/ItineraryWidget/ItineraryWidget';
import { getStorage, setStorage } from '@go-client/lib/storage';
import Config from '@go-client/lib/config';
import { MultiDaySettings } from '@go-client/components/FeedEditor/MultiDaySettings';
import { getMaxRundownFont, getMinRundownFont } from '@go-shared/lib/property';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CanvasContentForm, {
  CanvasContentFormMode,
} from '@go-client/components/CanvasContentForm/CanvasContentForm';
import { BareContent, Content } from '@go-shared/types/content';
import { bare as bareContent } from '@go-client/lib/content';
import { bare as bareEvent } from '@go-client/lib/event';
import CanvasEventForm, {
  CanvasEventFormMode,
} from '@go-client/components/CanvasEventForm/CanvasEventForm';
import { StaffTemplate } from '@go-shared/types/staffTemplate';
import { BareGroupEvent } from '@go-shared/types/groupEvent';
import ContentTemplateFormik from '@go-client/components/Formik/ContentTemplateFormik';
import { bare, bareSailingDay, getDailyProgram } from '@go-shared/lib/itinerary';
import { DailyProgram } from '@go-shared/types/dailyProgram';
import DailySchedulePanel from '@go-client/components/DailySchedulePanel/DailySchedulePanel';
import { getPrintProgramMcmEndpoint } from '@go-shared/lib/mcm';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { EventRundownEditor } from '@go-client/components/FeedEditor/EventRundown/EventRundownEditor';
import { FeedEditorFeeds } from '@go-client/components/FeedEditor/Menu/FeedEditorFeeds';
import { EventBlurbSettings } from '@go-client/components/FeedEditor/ContentSidebar/Blurbs/EventBlurbs/EventBlurbs';
import { DEFAULT_TIMESTR_FORMAT } from '@go-shared/lib/time';

const PAGE_STACK_LENGTH = 20;

export interface FeedEditorInfo {
  plan: Plan;
  feeds: BareFeedTemplate[];
  groupEvts: BareGroupEvent[];
  template?: BareTemplate;
  dayBundle?: SailingDayBundle;
  nextFeedDayLink?: string;
  prevFeedDayLink?: string;
  pathToPlanner?: string;
  skipTemplates?: boolean;
}

export interface ExportProgramParams {
  language?: string;
  hideBackground: boolean;
}

interface BulkLibraries {
  events: Event[];
  eventTemplates: EventTemplate[];
  bareEventTemplates: BareEventTemplate[];
  venueTemplates: VenueTemplate[];
  bareVenueTemplates: BareVenueTemplate[];
  contentTemplates: BareContentTemplate[];
  staffTemplates: StaffTemplate[];
}

interface BulkTranslations {
  eventTemplateTranslations: EventTemplateTranslation[];
  venueTemplateTranslations: VenueTemplateTranslation[];
  contentTemplateTranslations: ContentTemplateTranslation[];
  mpTranslations: MealPeriodTranslation[];
  commonTextTranslations: CommonTextTranslation[];
  venueTypeTranslations: VenueTypeTranslation[];
  segmentTranslations: SegmentTranslation[];
  levelTranslations: LevelTranslation[];
  attributeTranslations: AttributeTranslation[];
  contentSegmentTranslations: ContentSegmentTranslation[];
  contentLevelTranslations: ContentLevelTranslation[];
  contentAttributeTranslations: ContentAttributeTranslation[];
  highlightTranslations: HighlightTranslation[];
  dayThemeTranslations: DayThemeTranslation[];
}

interface CreateTemplateData {
  sailing: BareSimpleSailing;
  sailingDay: BareSimpleSailingDay;
  templateData: TemplateFormDataBase;
}

interface FeedEditorPagePropsBase {
  variant: 'navy' | 'velvet';
  user: User;
  property: Property;
  languages: Language[];
  defaultLanguage: Language;
  settingsPanel: FeedEditorSettingsPanel | undefined;
  editorInfo?: FeedEditorInfo;
  hideGroupEvents?: boolean;
  showDailyProgramFeedOptions: boolean;
  needsRefresh: (skipTemplates?: boolean) => Promise<void>;
  setSettingsPanel: (settingsPanel: FeedEditorSettingsPanel | undefined) => void;
  refreshActiveProperty: () => Promise<void>;
  onUpdateProgram: (page: FeedPage, feedSlot: number) => Promise<void>;
  onExportProgram?: (params: ExportProgramParams, feedSlot: number) => Promise<void>;
  onSailingDayNameClick?: (sailing: BareSimpleSailing, sailingDay: BareSimpleSailingDay) => void;
  onCreateContent?: (content: BareContent) => Promise<unknown>;
  onUpdateContent?: (content: BareContent, transferToTargetDay?: string) => Promise<unknown>;
  onDeleteContent?: (contentId: string) => Promise<unknown>;
  onUpdateEvent?: (
    event: BareEvent,
    applyStaffToPlan?: boolean,
    key?: string,
    transferToTargetDay?: string
  ) => Promise<unknown>;
  onCreateEvent?: (
    event: BareEvent,
    applyStaffToPlan?: boolean,
    transferToTargetDay?: string
  ) => Promise<unknown>;
  onDeleteEvent?: (eventId: string) => Promise<unknown>;
  onUpdateVenue?: (venue: VenueDisposition) => Promise<unknown>;
}

const ZOOM_INCREMENT = 1;
const RUNDOWN_FONT_SIZE_INCREMENT = 0.5;

type FeedEditorPageProps = FeedEditorPagePropsBase & RouteComponentProps;

export function FeedEditor(_props: FeedEditorPageProps) {
  const context = useContext(FeedEditorCtx);

  const {
    variant,
    languages,
    defaultLanguage,
    settingsPanel,
    setSettingsPanel,
    needsRefresh,
    refreshActiveProperty,
    editorInfo,
    onExportProgram,
    onUpdateProgram,
    onSailingDayNameClick,
    showDailyProgramFeedOptions,
    onCreateContent,
    onDeleteContent,
    onUpdateContent,
    onUpdateEvent,
    onCreateEvent,
    onDeleteEvent,
    onUpdateVenue,
    ...rest
  } = _props;

  const { property, user } = rest;
  const dayBundle = editorInfo?.dayBundle;

  const storage = getStorage();
  const [exporting, setExporting] = useState(false);
  const [refreshed, setRefreshed] = useState(false);
  const [contextLoaded, setContextLoaded] = useState(false);
  // const [showArchived, setShowArchived] = useState(false);
  const showArchived = false;
  const [actionsVisible, setActionsVisible] = useState(true);
  // const [previewVars, setPreviewVars] = useState(true);
  const previewVars = true;
  const [highlightAreas, setHighlightAreas] = useState(true);
  const [showTemplateLinkForm, setShowTemplateLinkForm] = useState(false);
  const [showTemplateViewForm, setShowTemplateViewForm] = useState(false);
  const [showCreateTemplateForm, setShowCreateTemplateForm] = useState(false);
  const [rundownFontSize, setRundownFontSize] = useState(RUNDOWN_DEFAULT_FONT_SIZE);
  const [zoom, setZoom] = useState(Math.min(Math.max(storage.feedZoom || 10, 1), 20));
  const [settingsPanelRight, setSettingsPanelRight] = useState(true);
  const [simulateMargins, setSimulateMargins] = useState(!!storage.simulateMargins);
  const { settings } = useServerInfo();

  const [original, setOriginal] = useState<BulkLibraries>({
    events: [],
    eventTemplates: [],
    bareEventTemplates: [],
    venueTemplates: [],
    bareVenueTemplates: [],
    contentTemplates: [],
    staffTemplates: [],
  });
  const [translated, setTranslated] = useState<BulkLibraries | undefined>(undefined);
  const [selectedLanguage, setSelectedLanguage] = useState<Language>(defaultLanguage);
  const [translations, setTranslations] = useState<BulkTranslations>({
    eventTemplateTranslations: [],
    venueTemplateTranslations: [],
    contentTemplateTranslations: [],
    mpTranslations: [],
    commonTextTranslations: [],
    venueTypeTranslations: [],
    segmentTranslations: [],
    levelTranslations: [],
    attributeTranslations: [],
    highlightTranslations: [],
    dayThemeTranslations: [],
    contentSegmentTranslations: [],
    contentLevelTranslations: [],
    contentAttributeTranslations: [],
  });
  const [currentPageStacks, setCurrentPageStacks] = useState<{ [key: string]: FeedPage[] }>({});
  const [feedSlot, setFeedSlot] = useState<number>(0);
  const [feedTemplate, setFeedTemplate] = useState<FeedTemplate | undefined>(undefined);
  const [currentPage, setCurrentPage] = useState<FeedPage | undefined>(undefined);
  const [skipPageLoad, setSkipPageLoad] = useState<boolean>(false);

  const [createTemplateForm, setCreateTemplateForm] = useState<CreateTemplateData | undefined>(
    undefined
  );

  const [dailyProgram, setDailyProgram] = useState<DailyProgram | undefined>(undefined);

  useEffect(() => {
    setStorage('feedZoom', zoom);
    setStorage('simulateMargins', simulateMargins);
  }, [zoom, simulateMargins]);

  const feedBodyRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setTimeout(() => {
      if (!feedBodyRef?.current) return;

      const { feedScrollLeft, feedScrollTop } = storage;
      if (!feedScrollLeft || !feedScrollTop) return;

      feedBodyRef.current.scrollTo(feedScrollLeft, feedScrollTop);
    });
  }, [currentPage]);

  useEffect(() => {
    setTimeout(() => {
      if (!feedBodyRef?.current) return;
      setActiveElement('');
      feedBodyRef.current.focus();
    });
  }, [currentPage]);

  function handleOnFeedScroll(evt: React.UIEvent<HTMLDivElement, UIEvent>) {
    const el = evt.currentTarget as HTMLDivElement;
    setStorage('feedScrollLeft', el.scrollLeft);
    setStorage('feedScrollTop', el.scrollTop);
  }

  async function refresh() {
    if (!editorInfo) return;

    const [contentTemplates, bareEventTemplates, bareVenueTemplates, bareStaffTemplates] =
      await Promise.all([
        getContentTemplates(property._id),
        getPropertyEventTemplates(property._id),
        getVenueTemplatesByPropertyId(property._id),
        getStaffTemplatesByPropertyId(property._id),
      ]);

    const contentTemplateIds = contentTemplates.map(ct => ct._id);
    const eventTemplateIds = bareEventTemplates.map(et => et._id);
    const venueTemplateIds = bareVenueTemplates.map(vt => vt._id);

    const [
      eventTemplateTranslations,
      venueTemplateTranslations,
      contentTemplateTranslations,
      mpTranslations,
      commonTextTranslations,
      venueTypeTranslations,
      segmentTranslations,
      levelTranslations,
      attributeTranslations,
      highlightTranslations,
      dayThemeTranslations,
      contentSegmentTranslations,
      contentLevelTranslations,
      contentAttributeTranslations,
    ] = await Promise.all([
      getTranslationsByRefers('eventtemplate', eventTemplateIds),
      getTranslationsByRefers('venuetemplate', venueTemplateIds),
      getTranslationsByRefers('contenttemplate', contentTemplateIds),
      getTranslations(property._id, 'mealperiod'),
      getTranslations(property._id, 'commonText'),
      getTranslations(property._id, 'venuetype'),
      getTranslations(property._id, 'segment'),
      getTranslations(property._id, 'level'),
      getTranslations(property._id, 'attribute'),
      getTranslations(property._id, 'highlight'),
      getTranslations(property._id, 'daytheme'),
      getTranslations(property._id, 'contentSegment'),
      getTranslations(property._id, 'contentLevel'),
      getTranslations(property._id, 'contentAttribute'),
    ]);

    setTranslations({
      eventTemplateTranslations,
      venueTemplateTranslations,
      contentTemplateTranslations,
      mpTranslations,
      commonTextTranslations,
      venueTypeTranslations,
      segmentTranslations,
      levelTranslations,
      attributeTranslations,
      highlightTranslations,
      dayThemeTranslations,
      contentSegmentTranslations,
      contentLevelTranslations,
      contentAttributeTranslations,
    });

    const eventTemplates = bareEventTemplates.map(et =>
      populateEventTemplate(et, editorInfo.plan.property.brand)
    );

    const venueTemplates = bareVenueTemplates.map(vt =>
      populateVenueTemplate(vt, editorInfo.plan.property)
    );

    const staffTemplates = bareStaffTemplates.map(st =>
      populateStaffTemplate(st, editorInfo.plan.property)
    );

    const events = editorInfo.plan.events
      .filter(e => !e.hidden)
      .map(bareEvent => {
        try {
          return populateEvent(
            bareEvent,
            eventTemplates,
            venueTemplates,
            staffTemplates,
            editorInfo.plan.day
          );
        } catch (err) {
          console.error(getErrorMessage(err));
          return;
        }
      })
      .filter(notUndefined)
      .filter(e => !e.template.crewOnly);

    const dayEvents = events.filter(e => e.day._id === editorInfo.plan.day._id);

    setOriginal({
      events: dayEvents,
      eventTemplates,
      bareEventTemplates,
      venueTemplates,
      bareVenueTemplates,
      contentTemplates,
      staffTemplates,
    });

    loadFeed(feedSlot);

    setRefreshed(true);
  }

  function loadFeed(feedSlot: number) {
    if (!editorInfo) return;

    const bareFeed = editorInfo.feeds[feedSlot];
    if (!bareFeed) return;

    setFeedSlot(feedSlot);
    const feedTmpl = populateFeed(
      bareFeed,
      property,
      original.contentTemplates.map(ct => convertContentTemplateToLegacy(ct, property))
    );

    setFeedTemplate(feedTmpl);

    const page = feedTmpl.pages.length > 0 ? feedTmpl.pages[0] : undefined;

    if (!currentPage || !skipPageLoad) {
      setCurrentPage(page);
    }

    setSkipPageLoad(false);

    // start undo history with first page
    const pageStacks: { [key: string]: FeedPage[] } = {};
    feedTmpl.pages.forEach(p => {
      pageStacks[p._id] = [JSON.parse(JSON.stringify(p))];
    });

    setCurrentPageStacks(pageStacks);

    upsertCustomStyleElement(feedTmpl.customAreasCss);
    upsertFontsElement(feedTmpl.fonts);
  }

  useEffect(() => {
    if (!editorInfo) return;

    context.setPlan(editorInfo.plan);
    context.setProperty(property);

    context.setEvents(translated?.events ?? original.events);
    context.setVenueTemplates(translated?.venueTemplates ?? original.venueTemplates);
    context.setEventTemplates(translated?.eventTemplates ?? original.eventTemplates);
    context.setContentTemplates(translated?.contentTemplates ?? original.contentTemplates);

    context.setMpTranslations(translations.mpTranslations);
    context.setCommonTextTranslations(translations.commonTextTranslations);

    // FIXME: This may not be safe; before it would always expect a sailing day
    if (editorInfo.dayBundle) {
      context.setSailingDay(bareSailingDay(editorInfo.dayBundle.day));
      context.setSailing(bare(editorInfo.dayBundle.sailing));
    }

    if (feedTemplate?.fonts) {
      context.setFonts(feedTemplate.fonts);
    }

    context.setRundownFontSize(currentPage?.rundownFontSize || RUNDOWN_DEFAULT_FONT_SIZE);
    setContextLoaded(refreshed);

    const dp = getDailyProgram({
      baseUrl: '/',
      endpoint: getPrintProgramMcmEndpoint(feedTemplate),
      publisherRole: settings.PUBLISHER_ROLE,
      property,
      plan: {
        ...editorInfo?.plan,
        property: editorInfo?.plan.property._id,
      },
      dayBundle: editorInfo?.dayBundle,
      eventTemplates: original.bareEventTemplates,
      eventTemplateTranslations: translations.eventTemplateTranslations,
      venueTemplates: original.bareVenueTemplates,
      venueTemplateTranslations: translations.venueTemplateTranslations,
      contentTemplates: original.contentTemplates,
      contentTemplateTranslations: translations.contentTemplateTranslations,
      commonTextTranslations: translations.commonTextTranslations,
      venueTypeTranslations: translations.venueTypeTranslations,
      mealPeriodTranslations: translations.mpTranslations,
      segmentTranslations: translations.segmentTranslations,
      levelTranslations: translations.levelTranslations,
      attributeTranslations: translations.attributeTranslations,
      contentAttributeTranslations: translations.contentAttributeTranslations,
      contentSegmentTranslations: translations.contentSegmentTranslations,
      contentLevelTranslations: translations.contentLevelTranslations,
      highlightTranslations: translations.highlightTranslations,
      dayThemeTranslations: translations.dayThemeTranslations,
      languages: languages.map(l => l.key),
      defaultLanguage: defaultLanguage.key,
      selectedLanguage: selectedLanguage.key,
      images: [],
      settings: {
        eventTimeStringStyle: DEFAULT_TIMESTR_FORMAT,
        venueTimeStringStyle: DEFAULT_TIMESTR_FORMAT,
      },
    });

    setDailyProgram(dp);
    context.setDailyProgram(dp);
  }, [editorInfo, property, translated, original, feedTemplate, currentPage, refreshed]);

  useEffect(() => {
    if (editorInfo && !editorInfo.skipTemplates) {
      refresh();
    }
  }, [editorInfo]);

  useEffect(() => {
    setRefreshed(false);
  }, [_props.history.location]);

  useEffect(() => {
    const { events, eventTemplates, venueTemplates, contentTemplates, staffTemplates } = original;

    let evts: Event[] = [];
    let ets: EventTemplate[] = [];
    let vts: VenueTemplate[] = [];
    let cnts: BareContentTemplate[] = [];
    let sts: StaffTemplate[] = [];

    if (!selectedLanguage || selectedLanguage.key === defaultLanguage.key) {
      // revert
      evts = events.filter(e => !e.template.notNative);
      ets = eventTemplates;
      vts = venueTemplates;
      cnts = contentTemplates;
      sts = staffTemplates;
      setTranslated(undefined);
    } else {
      // translate
      evts = events
        .map(e => {
          const template = translateEventTemplate(
            e.template,
            translations.eventTemplateTranslations.find(trns =>
              safeIdCompare(trns.refers, e.template._id)
            ),
            selectedLanguage.key
          );

          return !template ? undefined : { ...e, template };
        })
        .filter(notUndefined);
      ets = eventTemplates.map(
        et =>
          translateEventTemplate(
            et,
            translations.eventTemplateTranslations.find(trns => safeIdCompare(trns.refers, et._id)),
            selectedLanguage.key
          ) || et
      );
      vts = venueTemplates.map(
        vt =>
          translateVenueTemplate(
            vt,
            translations.venueTemplateTranslations.find(trns => safeIdCompare(trns.refers, vt._id)),
            selectedLanguage.key
          ) || vt
      );
      cnts = contentTemplates
        .map(ct =>
          translateBareContentTemplate(
            ct,
            translations.contentTemplateTranslations.find(trns =>
              safeIdCompare(trns.refers, ct._id)
            ),
            selectedLanguage.key
          )
        )
        .filter(notUndefined);

      setTranslated({
        events: evts,
        eventTemplates: ets, // FIXME: is this right?
        bareEventTemplates: original.bareEventTemplates,
        venueTemplates: vts,
        bareVenueTemplates: original.bareVenueTemplates,
        contentTemplates: cnts,
        staffTemplates: sts,
      });
    }

    // merged vars step
    if (selectedLanguage && previewVars) {
      evts = evts.map(e => {
        const [title] = evaluateMergedVars(
          e.template.title,
          dayBundle,
          languages.map(l => l.key),
          selectedLanguage.key,
          defaultLanguage.key,
          e.mergedVars
        );

        const [description] = evaluateMergedVars(
          e.template.description,
          dayBundle,
          languages.map(l => l.key),
          selectedLanguage.key,
          defaultLanguage.key,
          e.mergedVars
        );

        return { ...e, template: { ...e.template, title, description } };
      });
    }
  }, [original, languages, selectedLanguage, defaultLanguage, translations, previewVars]);

  async function handleOnExportProgram(hideBackground: boolean) {
    try {
      setExporting(true);
      if (onExportProgram) {
        let language = selectedLanguage?.key;
        await onExportProgram({ language, hideBackground }, feedSlot);
      }
    } finally {
      setExporting(false);
    }
  }

  async function revertChanges() {
    if (!currentPage) return;

    const cpId = currentPage._id;
    const cpStack = currentPageStacks[cpId];

    if (!cpStack || cpStack.length < 2) return;

    cpStack.pop();
    const peekCp = JSON.parse(JSON.stringify(cpStack[cpStack.length - 1]));

    // also make updates to feed template
    const existingTemplate = feedTemplate;
    const idx = existingTemplate?.pages.findIndex(p => p._id === peekCp._id);
    if (idx !== undefined && idx > -1) existingTemplate?.pages.splice(idx, 1, peekCp);

    setCurrentPage(peekCp);
    setCurrentPageStacks({
      ...currentPageStacks,
      [cpId]: cpStack,
    });
    setFeedTemplate(existingTemplate);

    await onUpdateProgram(peekCp, feedSlot);
  }

  function getActiveContentTemplatesLegacy() {
    return translated
      ? translated.contentTemplates.map(ct => convertContentTemplateToLegacy(ct, property))
      : original.contentTemplates.map(ct => convertContentTemplateToLegacy(ct, property));
  }

  function getActiveContentTemplates() {
    return translated ? translated.contentTemplates : original.contentTemplates;
  }

  function getActiveEvents(filterNotNative?: boolean) {
    if (translated) {
      return translated.events;
    }
    // FIXME: original events would not have the merged vars unlike translated ones
    // which means we need to repeat this logic. This needs to be done better...
    let events = original.events.map(e => {
      if (!selectedLanguage || !previewVars) return e;

      const [title] = evaluateMergedVars(
        e.template.title,
        dayBundle,
        languages.map(l => l.key),
        selectedLanguage.key,
        defaultLanguage.key,
        e.mergedVars
      );

      const [description] = evaluateMergedVars(
        e.template.description,
        dayBundle,
        languages.map(l => l.key),
        selectedLanguage.key,
        defaultLanguage.key,
        e.mergedVars
      );

      return { ...e, template: { ...e.template, title, description } };
    });

    if (filterNotNative) {
      events = events.filter(e => !e.template.notNative);
    }

    return events;
  }

  function getActiveVenueTemplates() {
    return translated ? translated.venueTemplates : original.venueTemplates;
  }

  function handleOnKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    if (!currentPage || settingsPanel) return;

    if (e.shiftKey) {
      // do row movement
      if (e.key === 'ArrowUp') {
        // move to row up
        const parent = findAreaParent(currentPage, activeElement);
        if (parent?.contentType === 'row') {
          // coming from a column
          setActiveElement(parent?._id);
          return;
        }
        if (parent?.contentType !== 'static') return;
        const idx = (parent?.children || []).findIndex(a => a._id === activeElement);
        let nextEl = (parent?.children || [])[idx - 1];
        if (!nextEl) {
          // need to jump over to previous area
          const areaIdx = currentPage.areas.findIndex(a => a._id === parent?._id);
          let nextArea = currentPage.areas[areaIdx - 1];
          if (!nextArea) nextArea = lastEl(currentPage.areas);
          const child = lastEl(nextArea.children || []);
          if (!child) return;
          setActiveElement(child._id);
          return;
        }
        e.stopPropagation();
        e.preventDefault();
        setActiveElement(nextEl._id);
      } else if (e.key === 'ArrowDown') {
        // move to row down
        const parent = findAreaParent(currentPage, activeElement);
        if (parent?.contentType === 'row') {
          // coming from a column
          setActiveElement(parent?._id);
          return;
        }
        if (parent?.contentType !== 'static') return;
        const idx = (parent?.children || []).findIndex(a => a._id === activeElement);
        let nextEl = (parent?.children || [])[idx + 1];
        if (!nextEl) {
          // need to jump over to previous area
          const areaIdx = currentPage.areas.findIndex(a => a._id === parent?._id);
          let nextArea = currentPage.areas[areaIdx + 1];
          if (!nextArea) nextArea = firstEl(currentPage.areas);
          const child = (nextArea.children || [])[0];
          if (!child) return;
          setActiveElement(child._id);
          return;
        }
        if (!nextEl) return;
        e.stopPropagation();
        e.preventDefault();
        setActiveElement(nextEl._id);
      } else if (e.key === 'ArrowLeft') {
        // move to col up
        const parent = findAreaParent(currentPage, activeElement);
        const idx = (parent?.children || []).findIndex(a => a._id === activeElement);
        if (parent?.contentType === 'static') {
          // coming from a row
          const child = (parent?.children || [])[idx];
          if (!child) return;
          const subchild = (child.children || [])[0];
          if (!subchild) return;
          setActiveElement(subchild._id);
          return;
        }
        if (parent?.contentType !== 'row') return;
        let nextEl = (parent?.children || [])[idx - 1];
        if (!nextEl) nextEl = lastEl(parent?.children || []);
        if (!nextEl) return;
        e.stopPropagation();
        e.preventDefault();
        setActiveElement(nextEl._id);
      } else if (e.key === 'ArrowRight') {
        // move to col down
        const parent = findAreaParent(currentPage, activeElement);
        const idx = (parent?.children || []).findIndex(a => a._id === activeElement);
        if (parent?.contentType === 'static') {
          // coming from a row
          const child = (parent?.children || [])[idx];
          if (!child) return;
          const subchild = (child.children || [])[0];
          if (!subchild) return;
          setActiveElement(subchild._id);
          return;
        }
        if (parent?.contentType !== 'row') return;
        let nextEl = (parent?.children || [])[idx + 1];
        if (!nextEl) nextEl = firstEl(parent?.children || []);
        if (!nextEl) return;
        e.stopPropagation();
        e.preventDefault();
        setActiveElement(nextEl._id);
      }
    } else if (e.ctrlKey || e.metaKey) {
      if (e.key === 'c' || e.key === 'C') {
        // do copy
        const source = findArea(currentPage, activeElement);
        if (source?.isLocked) return;

        setCopyElement({ action: 'copy', id: activeElement, pageId: currentPage._id });
      } else if (e.key === 'v' || e.key === 'V') {
        // do paste
        if (!copyElement || !feedTemplate) return;

        const sourcePageIdx = feedTemplate.pages.findIndex(p => p._id === copyElement.pageId);
        if (sourcePageIdx === undefined || sourcePageIdx < 0) return;

        const source = findArea(feedTemplate.pages[sourcePageIdx], copyElement.id);
        if (!source || source.isLocked) return;

        const parentOfTarget = findAreaParent(currentPage, activeElement);
        if (!parentOfTarget || !parentOfTarget.children || parentOfTarget.isLocked) return;

        const childIndex = parentOfTarget.children.findIndex(child => child._id === activeElement);
        if (parentOfTarget.contentType !== 'row' || childIndex < 0) return;

        e.stopPropagation();
        e.preventDefault();

        const sourceCopy = unsafeDeepCopy(source);
        washIds(sourceCopy);
        parentOfTarget.children.splice(childIndex, 1, sourceCopy);

        saveChanges(currentPage);

        setTimeout(() => {
          setActiveElement(sourceCopy._id);
        });
      } else if (e.key === 'z' || e.key === 'Z') {
        // do undo
        if (!currentPage || currentPageStacks[currentPage?._id ?? -1]?.length < 2) return;
        revertChanges();
      } else if (e.key === 'h' || e.key === 'H') {
        // do toggle highlight
        e.stopPropagation();
        e.preventDefault();
        setHighlightAreas(!highlightAreas);
      }
    }

    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', 'Backspace'].includes(e.key)) {
      context.setKbEvent({
        key: e.key,
        elemId: activeElement,
        timestamp: Date.now(),
      });
    }
  }

  async function saveChanges(page: FeedPage) {
    const cpId = page._id;
    const cpStack = currentPageStacks[cpId] || [];

    cpStack.push(JSON.parse(JSON.stringify(page)));

    while (cpStack.length > PAGE_STACK_LENGTH) {
      cpStack.shift();
    }

    // also make updates to feed template
    const existingTemplate = feedTemplate;
    const idx = existingTemplate?.pages.findIndex(p => p._id === page._id);
    if (idx !== undefined && idx > -1) existingTemplate?.pages.splice(idx, 1, page);

    setCurrentPage(page);
    setCurrentPageStacks({ ...currentPageStacks, [page._id]: cpStack });
    setFeedTemplate(existingTemplate);

    await onUpdateProgram(page, feedSlot);
  }

  async function handleOnUnlinkTemplateFragments(linkFragments: StrategicLinkFragment[]) {
    await unlinkTemplateFragments(property._id, linkFragments);
    setShowTemplateLinkForm(false);
    needsRefresh();
  }

  async function handleOnFinishLinkTemplateFragments(linkFragments: LinkFragment[]) {
    await linkTemplateFragments(property._id, linkFragments);
    setShowTemplateLinkForm(false);
    needsRefresh();
  }

  function handleOnCreateTemplateFormClick(
    sailing: BareSimpleSailing,
    sailingDay: BareSimpleSailingDay
  ) {
    setShowCreateTemplateForm(true);
    setCreateTemplateForm({
      sailing,
      sailingDay,
      templateData: {
        placeholder: `Copy of ${sailing.name} (Day ${sailingDay.name})`,
        name: '',
        tags: [],
      },
    });
  }

  async function handleOnCreateTemplateFromSailingDay(templateData: TemplateFormDataBase) {
    if (!createTemplateForm) return;

    await createTemplateFromSailingDay(
      createTemplateForm.sailing._id,
      createTemplateForm.sailingDay._id,
      {
        name: templateData.name,
        tags: templateData.tags.map(t => t._id),
        ...(templateData.dayTheme && { dayTheme: templateData.dayTheme }),
      }
    );

    setShowCreateTemplateForm(false);
    needsRefresh();
  }

  function handleContentChange(area: FeedArea, contentTemplate: BareContentTemplateLegacy) {
    if (!currentPage) return;

    const match = findArea(currentPage, area._id);

    if (contentTemplate.params) {
      if (contentTemplate.params.widgetType === 'date-widget' && match) {
        match.children = [SailingDateWidget.getArea(contentTemplate)];
        delete match.content;
      } else if (contentTemplate.params.widgetType === 'itinerary-widget' && match) {
        match.children = [ItineraryWidget.getArea(contentTemplate)];
        delete match.content;
      } else if (contentTemplate.params.eventId && match) {
        match.content = {
          content: contentTemplate.content,
          _id: '',
          name: 'Event',
          property: property._id,
          params: contentTemplate.params,
        };
        match.children = [];
      } else if (contentTemplate.params.widgetType === 'event-rundown' && match) {
        match.children = [
          {
            contentType: 'event-rundown',
            content: contentTemplate,
            _id: new ObjectId().toHexString(),
            name: 'Event Rundown',
            rectangle: {
              x: 0,
              y: 0,
              width: 0,
              height: 0,
            },
            style: {},
            className: '',
          },
        ];
      } else if (contentTemplate.params.venueRundownConfig && match) {
        match.children = [
          {
            contentType: 'venue-rundown',
            content: contentTemplate,
            _id: new ObjectId().toHexString(),
            name: 'Venue Rundown',
            rectangle: {
              x: 0,
              y: 0,
              width: 0,
              height: 0,
            },
            style: {},
            className: '',
          },
        ];
        delete match.content;
      } else if (contentTemplate.params.venueMealPeriodsConfig && match) {
        match.children = [
          {
            contentType: 'venue-meal-periods',
            content: contentTemplate,
            _id: new ObjectId().toHexString(),
            name: 'Venue Meal Periods',
            rectangle: {
              x: 0,
              y: 0,
              width: 0,
              height: 0,
            },
            style: {},
            className: '',
          },
        ];
        delete match.content;
      }
    } else if (match) {
      match.content = {
        content: contentTemplate._id,
        _id: '',
        name: 'Custom',
        property: property._id,
      };
      match.children = [];
    }

    // This is recreating the database update here, also this will make the UI smooth
    // with no backend delays, the idea is to do this:

    /**
     *
     * MODIFY => UPDATE STATE CLIENT SIDE USING OPTIMISTIC STATE => SEND UPDATE TO API
     *
     */

    // If the API update fails (it shouldn't), we will inform the user after the UI update,
    // and we will go back to the old state
    saveChanges(currentPage);
  }

  function handleVenueRundownUpdate(feedArea: FeedArea, _: string, vts: VenueTemplate[]) {
    if (!currentPage) return;

    const match = findArea(currentPage, feedArea._id);
    const venueTemplateIds = vts.map(vt => vt._id);

    if (match && match.content && match.content.params) {
      match.content.params.venueRundownConfig! = venueTemplateIds;
    }

    saveChanges(currentPage);
  }

  function handleEventRundownUpdate(updatedArea: FeedArea) {
    if (!currentPage) return;

    const match = findArea(currentPage, updatedArea._id);

    if (match) {
      Object.assign(match, updatedArea);
      saveChanges(currentPage);
    }
  }

  function handleVenueMealPeriodsUpdate(feedArea: FeedArea, _: string, vts: VenueTemplate[]) {
    if (!currentPage) return;

    const match = findArea(currentPage, feedArea._id);
    const venueTemplateIds = vts.map(vt => vt._id);

    if (match && match.content && match.content.params) {
      match.content.params.venueMealPeriodsConfig! = venueTemplateIds;
    }

    saveChanges(currentPage);
  }

  function handleMultiDayConfigUpdated({
    feedArea,
    startDate,
    endDate,
  }: {
    feedArea: FeedArea;
    startDate: string;
    endDate: string;
  }) {
    if (!currentPage) return;

    const area = findArea(currentPage, feedArea._id);

    if (area && !area?.params) {
      area.params = {};
    }

    if (area?.params) {
      area.params.multiDayConfig = {
        startDate,
        endDate,
      };

      saveChanges(currentPage);
    }
  }

  function handleContentBlurbUpdate(
    feed: FeedArea,
    _: string,
    replaceDict: ReplacedDict,
    translDict: TranslatedReplacedDict
  ) {
    if (!currentPage) return;

    const match = findArea(currentPage, feed._id);

    if (match && match.content) {
      (match.content as any).replacements = replaceDict;
      (match.content as any).translations = translDict;
    }

    saveChanges(currentPage);
  }

  function handleEventBlurbUpdate(feed: FeedArea, _: string, eventTemplateInstance: number) {
    if (!currentPage) return;

    const match = findArea(currentPage, feed._id);

    if (match && match.content) {
      (match.content as any).eventTemplateInstance =
        eventTemplateInstance ?? (match.content as any).eventTemplateInstance;
    }

    saveChanges(currentPage);
  }

  function handleLayoutComponentCreation(parentArea: FeedArea, idx: number, newArea: FeedArea) {
    if (!currentPage) return;

    const match = findArea(currentPage, parentArea._id);

    if (match) {
      if (!match.children) match.children = [];
      match.children.splice(idx, 0, newArea);

      saveChanges(currentPage);
    }
  }

  function handleLayoutComponentMove(parentArea: FeedArea, idx: number, direction: 1 | -1) {
    if (!currentPage) return;

    const match = findAreaParent(currentPage, parentArea._id);
    const newIdx = idx + direction;

    if (match && match.children && newIdx > -1 && newIdx < match.children.length) {
      move(match.children, idx, idx + direction);
      saveChanges(currentPage);
    }
  }

  function handleElementCreation(area: FeedArea, elementType: FeedEditorElementType) {
    if (!currentPage) return;

    const match = findArea(currentPage, area._id);
    if (match) {
      if (!match.children) {
        match.children = [];
      }
      switch (elementType) {
        case 'text':
          match.children.push(createText());
          break;
      }

      saveChanges(currentPage);
    }
  }

  function handleAreaDelete(area: FeedArea) {
    if (!currentPage) return;

    const match = findAreaParent(currentPage, area._id);

    if (match) {
      const childIndex = match.children!.findIndex(child => child._id === area._id);

      if (childIndex !== -1) {
        const parent = findAreaParent(currentPage, match._id);
        const parentIdx = (parent?.children || []).findIndex(c => c._id === match._id);

        match.children!.splice(childIndex, 1);

        let buffer = 0;

        if (parent?.children && match.children!.length === 0 && match.contentType === 'row') {
          parent.children.splice(parentIdx, 1);
          buffer = -1;
        }

        saveChanges(currentPage);

        setActiveElement(
          (match.children || [])[childIndex - 1]?._id ||
            (match.children || [])[0]?._id ||
            (parent?.children || [])[parentIdx + buffer]?._id ||
            (parent?.children || [])[0]?._id ||
            ''
        );
      }
    }
  }

  function handleElementChange(area: FeedArea) {
    if (!currentPage) return;

    const match = findArea(currentPage, area._id);
    if (match) {
      match.style = area.style;
      match.params = area.params;

      saveChanges(currentPage);
    }
  }

  async function onFontSizeIncreased(rundownFontSize: number, currentPage: FeedPage) {
    await onUpdateProgram({ ...currentPage, rundownFontSize }, feedSlot);
    currentPage.rundownFontSize = rundownFontSize;
  }

  async function onFontSizeDecreased(rundownFontSize: number, currentPage: FeedPage) {
    await onUpdateProgram({ ...currentPage, rundownFontSize }, feedSlot);
    currentPage.rundownFontSize = rundownFontSize;
  }

  const feedCanRender =
    contextLoaded && refreshed && editorInfo && feedTemplate && currentPage && dailyProgram;

  const accordions = [
    <div key="acc-1">
      {feedCanRender && (
        <FeedEditorPages
          pages={feedTemplate.pages}
          onPageClick={page => {
            setCurrentPage(page);
            if (page.rundownFontSize) {
              setRundownFontSize(page.rundownFontSize);
              context.setRundownFontSize(page.rundownFontSize);
            }
          }}
          currentPage={currentPage}
        />
      )}
    </div>,
    <div key="acc-2">
      {feedTemplate && (
        <FeedEditorFeeds
          feeds={editorInfo?.feeds ?? []}
          currentFeedId={feedTemplate._id}
          onFeedClick={(id: string) => {
            const feedIdx = (editorInfo?.feeds ?? []).findIndex(f => f._id === id);
            if (feedIdx > -1) {
              loadFeed(feedIdx);
            }
          }}
        />
      )}
    </div>,
  ];
  const accordionLabels = ['Pages', 'Feeds'];
  const accordionOpen = [0, 1];
  const [showDailySchedulePanel, setShowDailySchedulePanel] = useState(false);

  const [activeElement, setActiveElement] = useState<string>('');
  const [copyElement, setCopyElement] = useState<
    { action: 'copy'; id: string; pageId: string } | undefined
  >(undefined);
  const allowDoubleClickEditContentBlurb = selectedLanguage === defaultLanguage;

  const [contentFormMode, setContentFormMode] = useState<CanvasContentFormMode | undefined>(
    undefined
  );
  const [eventFormMode, setEventFormMode] = useState<CanvasEventFormMode | undefined>(undefined);

  async function handleContentUpdate(content: Content, transferToTargetDay?: string) {
    if (onUpdateContent) {
      await onUpdateContent(bareContent(content), transferToTargetDay);
    }

    needsRefresh(true);
  }

  async function handleEventUpdate(
    event: Event,
    applyStaffToPlan?: boolean,
    transferToTargetDay?: string
  ) {
    if (onUpdateEvent) {
      await onUpdateEvent(bareEvent(event), applyStaffToPlan, undefined, transferToTargetDay);
    }

    needsRefresh(true);
  }

  async function handleVenueUpdate(venue: VenueDisposition) {
    if (onUpdateVenue) {
      await onUpdateVenue(venue);
    }

    needsRefresh(true);
  }

  async function handleContentDelete(contentId: string) {
    if (onDeleteContent) await onDeleteContent(contentId);

    needsRefresh(true);
  }

  async function handleEventDelete(eventId: string) {
    if (onDeleteEvent) await onDeleteEvent(eventId);

    needsRefresh(true);
  }

  async function handleContentFormSubmit(content: Content, transferToTargetDay?: string) {
    if (!contentFormMode) return;

    const bc = bareContent(content);
    const { type: modeType } = contentFormMode;

    switch (modeType) {
      case 'create':
        if (onCreateContent) {
          await onCreateContent(bc);
        }
        break;
      case 'edit':
        if (onUpdateContent) {
          await onUpdateContent(bc, transferToTargetDay);
        }
        break;
    }

    needsRefresh(true);
    setContentFormMode(undefined);
  }

  async function handleEventFormSubmit(
    event: Event,
    applyStaffToPlan?: boolean,
    transferToTargetDay?: string
  ) {
    if (!eventFormMode) return;

    let be = bareEvent(event);
    const { type: modeType } = eventFormMode;

    switch (modeType) {
      case 'create':
        if (onCreateEvent) {
          await onCreateEvent(be, applyStaffToPlan);
        }
        break;
      case 'edit':
        if (onUpdateEvent) {
          await onUpdateEvent(be, applyStaffToPlan, undefined, transferToTargetDay);
        }
        break;
    }

    needsRefresh(true);
    setEventFormMode(undefined);
  }

  function openEventFormForEdit(event: Event) {
    if (!editorInfo) return;

    const { plan } = editorInfo;

    let editedEvent = eventToPartialEvent(event, plan.dayStart);

    const newEvtFormMode: CanvasEventFormMode = {
      type: 'edit',
      event: editedEvent,
      initialPage: 1,
      dayTransfer: dayBundle
        ? {
            current: bareSailingDay(dayBundle.day),
            options: dayBundle.sailing.days.map(bareSailingDay),
          }
        : undefined,
    };

    setEventFormMode(newEvtFormMode);
  }

  function openContentFormForEdit(content: Content) {
    if (!editorInfo) return;

    const newCntFormMode: CanvasContentFormMode = {
      type: 'edit',
      content: content,
      initialPage: 1,
      dayTransfer: dayBundle
        ? {
            current: bareSailingDay(dayBundle.day),
            options: dayBundle.sailing.days.map(bareSailingDay),
          }
        : undefined,
    };

    setContentFormMode(newCntFormMode);
  }

  const languageDropdownItems = [defaultLanguage, ...languages];

  const userCanEdit = canEditFeed(user);
  const dayIsLocked = isDayLocked(dayBundle?.day?.locked ?? false);
  const dayIsLinked = extractTemplateStatus(dayBundle?.day).templateStatus.feed === 'linked';
  const editorLocked = !userCanEdit || dayIsLocked || dayIsLinked;

  return (
    <div className="FeedEditor w-full h-full flex">
      <MenuBar {...rest} property={property} />
      <div className={`SideMenu bg-${variant}-darker flex flex-col relative`}>
        <div className="bg-white flex flex-col items-center">
          <BrandLogo logo={property.brand.logo} />
          <PropertyBanner {...rest} property={property} />
        </div>
        <div className={`flex flex-col relative items-stretch p-4 bg-${variant}-darker`}>
          <div className="grid gap-2">
            {actionsVisible && (
              <>
                <div className="grid grid-cols-3 gap-1">
                  <BubbleButton
                    variant="white"
                    iconClasses={`text-${variant}`}
                    disabled={!editorInfo?.prevFeedDayLink}
                    linkProps={{ to: editorInfo?.prevFeedDayLink || '#' }}
                    block
                    icon="arrow-left"
                  />
                  <BubbleButton
                    variant="white"
                    iconClasses={`text-${variant}`}
                    disabled={!editorInfo?.pathToPlanner}
                    linkProps={{ to: editorInfo?.pathToPlanner || '#' }}
                    block
                    icon={['fass', 'chart-tree-map']}
                  />
                  <BubbleButton
                    variant="white"
                    iconClasses={`text-${variant}`}
                    disabled={!editorInfo?.nextFeedDayLink}
                    linkProps={{ to: editorInfo?.nextFeedDayLink || '#' }}
                    block
                    icon="arrow-right"
                  />
                </div>
                {onExportProgram && (
                  <>
                    <div className="w-full flex items-stretch">
                      <BubbleOverlay
                        loading={exporting}
                        loadingClassName="rounded"
                        className="flex-grow"
                      >
                        <BubbleButton
                          block
                          variant="lime"
                          className="text-left pr-0-i"
                          onClick={() => handleOnExportProgram(false)}
                          icon="file-export"
                          style={{
                            borderTopRightRadius: 0,
                            borderBottomRightRadius: 0,
                          }}
                        >
                          Export Program
                        </BubbleButton>
                      </BubbleOverlay>
                      <div className="dropdown-inline-flex-fix items-stretch">
                        <Dropdown
                          items={[{ key: 'no-background', element: 'Export without background' }]}
                          className="flex items-stretch"
                          onSelect={() => handleOnExportProgram(true)}
                        >
                          {({ toggleRef, ...rest }) => (
                            <BubbleButton
                              buttonRef={toggleRef}
                              {...rest}
                              variant="lime"
                              className="shadow py-1-i px-2-i"
                              icon="chevron-down"
                              style={{
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                              }}
                            />
                          )}
                        </Dropdown>
                      </div>
                    </div>
                  </>
                )}
                <BubbleButton
                  variant="slate"
                  onClick={revertChanges}
                  disabled={!currentPage || currentPageStacks[currentPage?._id ?? -1]?.length < 2}
                  icon="rotate-left"
                  className="text-left"
                >
                  Undo Last Change
                </BubbleButton>
              </>
            )}
            <BubbleButton
              inverse
              onClick={() => {
                setActionsVisible(!actionsVisible);
              }}
              variant="white"
              className="py-0-i"
              icon={actionsVisible ? 'caret-up' : 'caret-down'}
              iconClasses={`-ml-3 ${actionsVisible ? 'text-smoke-lightest' : 'text-white'}`}
            >
              <span className={actionsVisible ? 'text-smoke-lightest' : 'text-white'}>
                {actionsVisible ? 'Collapse' : 'Show'} Actions
              </span>
            </BubbleButton>
          </div>
        </div>
        <BubbleOverlay
          className="h-full"
          hideBg
          loaderProps={{ style: { fill: 'white' } }}
          loading={!feedCanRender}
        >
          <BubbleAccordion
            variant={variant}
            className={`h-full flex flex-col border-t border-${variant}-darkest`}
            labels={accordionLabels}
            open={accordionOpen}
          >
            {accordions}
          </BubbleAccordion>
        </BubbleOverlay>
        {feedCanRender && !editorLocked && (
          <div className="FeedEditorSidebar fixed">
            <div className={`bg-${variant}-darkest h-full`}>
              <FeedEditorSidebar
                variant={variant}
                user={user}
                contentTemplates={getActiveContentTemplates().filter(
                  ct => showArchived || !ct.archived
                )}
                property={property}
                events={getActiveEvents().filter(e => showArchived || !e.template.archived)}
                dailyProgram={dailyProgram}
                onAddNewContentClick={() => {
                  context.setSelectedContent({
                    type: 'create',
                  });
                }}
                onContentDoubleClick={content => {
                  if (allowDoubleClickEditContentBlurb) {
                    context.setSelectedContent({
                      type: 'edit',
                      edit: populateContentTemplate(content, property.brand),
                    });
                  }
                }}
              />
            </div>
          </div>
        )}
      </div>

      <div className="FeedEditorBody bg-blue-lightest flex flex-col overflow-hidden w-full">
        <div
          className="FeedEditorHeader flex-shrink-0 align-with-logo flex items-end
          sticky top-0 left-0"
          style={{ height: '45px' }}
        >
          <div className="absolute top-0 left-0">
            {feedCanRender && (
              <SailingDayHeader
                day={dayBundle?.day}
                dayLocked={dayBundle?.day.locked ?? false}
                location={dayBundle ? getDayLocation(dayBundle.day) : undefined}
                date={dayBundle?.day.date}
                templateFragments={dayBundle?.day.templateFragments}
                templateHistory={dayBundle?.day.templateHistory}
                templateName={editorInfo.template?.name}
                onTemplateFragmentsClick={
                  dayBundle ? () => setShowTemplateLinkForm(true) : undefined
                }
                onTemplateNameClick={
                  editorInfo.template ? () => setShowTemplateViewForm(true) : undefined
                }
              />
            )}
          </div>
        </div>
        {feedCanRender ? (
          <div
            tabIndex={0}
            ref={feedBodyRef}
            onScroll={handleOnFeedScroll}
            className="InteractiveFeedWrapper flex-grow relative overflow-auto"
            style={{
              width: `${
                editorLocked ? '100%' : `calc(100% - 300px - ${showDailySchedulePanel ? 500 : 0}px)`
              }`,
            }}
            onKeyDown={handleOnKeyDown}
          >
            {settingsPanel && (
              <div
                className="FeedEditorSettingsPanel shadow-lg rounded"
                style={{
                  right: settingsPanelRight ? 300 + 10 : undefined,
                  left: !settingsPanelRight ? 230 + 10 : undefined,
                }}
              >
                <div className="inline-flex items-center w-full sticky top-0 bg-white border-b p-2 z-10">
                  {settingsPanel.type === 'content-settings' && (
                    <>
                      <BubbleButton variant="navy" inverse>
                        Replace Variables
                      </BubbleButton>
                    </>
                  )}
                  {settingsPanel.type === 'event-settings' && (
                    <>
                      <BubbleButton variant="navy" inverse>
                        Settings
                      </BubbleButton>
                    </>
                  )}
                  {settingsPanel.type === 'venue-rundown-settings' && (
                    <>
                      <BubbleButton
                        variant={settingsPanel.tab === 'venues' ? 'navy' : 'smoke'}
                        onClick={() => setSettingsPanel({ ...settingsPanel, tab: 'venues' })}
                        inverse
                      >
                        Select Venues
                      </BubbleButton>
                      <BubbleButton
                        variant={settingsPanel.tab === 'order' ? 'navy' : 'smoke'}
                        onClick={() => setSettingsPanel({ ...settingsPanel, tab: 'order' })}
                        inverse
                      >
                        Change Order
                      </BubbleButton>
                    </>
                  )}
                  {settingsPanel.type === 'venue-meal-periods-settings' && (
                    <>
                      <BubbleButton
                        variant={settingsPanel.tab === 'venues' ? 'navy' : 'smoke'}
                        onClick={() => setSettingsPanel({ ...settingsPanel, tab: 'venues' })}
                        inverse
                      >
                        Select Venues
                      </BubbleButton>
                      <BubbleButton
                        variant={settingsPanel.tab === 'order' ? 'navy' : 'smoke'}
                        onClick={() => setSettingsPanel({ ...settingsPanel, tab: 'order' })}
                        inverse
                      >
                        Change Order
                      </BubbleButton>
                    </>
                  )}
                  {settingsPanel.type === 'event-rundown-settings' && (
                    <>
                      <BubbleButton variant="navy" inverse>
                        Event Rundown Settings
                      </BubbleButton>
                    </>
                  )}
                  <BubbleButton
                    variant="navy"
                    inverse
                    onClick={() => setSettingsPanelRight(!settingsPanelRight)}
                    className="ml-auto"
                    icon="arrows-left-right"
                  />
                  <BubbleButton
                    variant="navy"
                    inverse
                    onClick={() => setSettingsPanel(undefined)}
                    icon="xmark-large"
                  />
                </div>
                {settingsPanel.type === 'content-settings' && (
                  <ContentBlurbSettings
                    key={settingsPanel.feedArea._id}
                    contentTemplate={settingsPanel.contentTemplate}
                    feedArea={settingsPanel.feedArea}
                    onContentBlurbUpdated={handleContentBlurbUpdate}
                  />
                )}
                {settingsPanel.type === 'event-settings' && (
                  <EventBlurbSettings
                    key={settingsPanel.feedArea._id}
                    contentTemplate={settingsPanel.contentTemplate}
                    feedArea={settingsPanel.feedArea}
                    onEventBlurbUpdated={handleEventBlurbUpdate}
                  />
                )}
                {settingsPanel.type === 'event-rundown-settings' && (
                  <EventRundownEditor
                    feedArea={settingsPanel.feedArea}
                    eventRundownId={settingsPanel.eventRundownId}
                    onEventRundownUpdated={handleEventRundownUpdate}
                  />
                )}
                {settingsPanel.type === 'venue-rundown-settings' && (
                  <VenueRundownEditor
                    tab={settingsPanel.tab}
                    feedArea={settingsPanel.feedArea}
                    venueRundownId={settingsPanel.venueRundownId}
                    selectedVenues={settingsPanel.selectedVenues}
                    venueTemplates={getActiveVenueTemplates().sort((a, b) =>
                      a.name.localeCompare(b.name)
                    )}
                    onSetSelectedVenues={vens =>
                      setSettingsPanel({ ...settingsPanel, selectedVenues: vens })
                    }
                    onVenueRundownUpdated={handleVenueRundownUpdate}
                  />
                )}
                {settingsPanel.type === 'venue-meal-periods-settings' && (
                  <VenueMealPeriodsEditor
                    tab={settingsPanel.tab}
                    feedArea={settingsPanel.feedArea}
                    venueMealPeriodsId={settingsPanel.venueMealPeriodsId}
                    selectedVenues={settingsPanel.selectedVenues}
                    venueTemplates={getActiveVenueTemplates().sort((a, b) =>
                      a.name.localeCompare(b.name)
                    )}
                    onSetSelectedVenues={vens =>
                      setSettingsPanel({ ...settingsPanel, selectedVenues: vens })
                    }
                    onVenueMealPeriodsUpdated={handleVenueMealPeriodsUpdate}
                  />
                )}
                {settingsPanel.type === 'multi-day-settings' && (
                  <MultiDaySettings
                    feedArea={settingsPanel.feedArea}
                    onMultiDayConfigUpdated={handleMultiDayConfigUpdated}
                  />
                )}
              </div>
            )}
            <DailySchedulePanel
              width={500}
              plan={editorInfo.plan}
              groupEvts={editorInfo.groupEvts.map(bareGroupEvent =>
                populateGroupEvent(
                  bareGroupEvent,
                  editorInfo.plan.property,
                  original.venueTemplates
                )
              )}
              dayBundle={dayBundle}
              eventTemplates={original.eventTemplates}
              venueTemplates={original.venueTemplates}
              contentTemplates={original.contentTemplates}
              staffTemplates={original.staffTemplates}
              eventTemplateTranslations={translations.eventTemplateTranslations}
              contentTemplateTranslations={translations.contentTemplateTranslations}
              venueTemplateTranslations={translations.venueTemplateTranslations}
              commonTextTranslations={translations.commonTextTranslations}
              open={showDailySchedulePanel}
              onToggle={setShowDailySchedulePanel}
              onAddBtnClick={activeTab => {
                switch (activeTab) {
                  case 'events':
                    setEventFormMode({
                      type: 'create',
                      event: {
                        startDay: editorInfo.plan.day,
                        staffAllocations: [],
                        highlights: [],
                      },
                    });
                    break;
                  case 'content':
                    setContentFormMode({ type: 'create' });
                    break;
                }
              }}
              style={{ right: editorLocked ? 0 : 300 }}
              onUpdateEvent={handleEventUpdate}
              onEditEvent={openEventFormForEdit}
              onRemoveEvent={handleEventDelete}
              onUpdateContent={handleContentUpdate}
              onEditContent={openContentFormForEdit}
              onRemoveContent={handleContentDelete}
              onUpdateVenue={handleVenueUpdate}
            />
            <div
              className="sticky bottom-0"
              style={{
                top: 'calc(100% - 60px)',
                left: 0,
                zIndex: 1,
              }}
            >
              <div className="flex items-stretch justify-center">
                {/* <Tooltip text="Preview Variables">
                  <BubbleButton
                    variant={variant}
                    className={`h-full rounded-right-0-i${
                      !previewVars
                        ? ` border-b-4 border-${variant}-darker`
                        : ` border-b-2 bg-${variant}-lighter-i border-${variant}-darker`
                    }`}
                    icon="dollar-sign"
                    onClick={() => {
                      setPreviewVars(!previewVars);
                    }}
                  />
                </Tooltip> */}
                <Tooltip text="Highlight Areas (CTRL+H)">
                  <BubbleButton
                    variant={variant}
                    // appearance="squared"
                    className={`h-full rounded-right-0-i${
                      !highlightAreas
                        ? ` border-b-4 border-${variant}-darker`
                        : ` border-b-2 bg-${variant}-lighter-i border-${variant}-darker`
                    }`}
                    icon="highlighter-line"
                    onClick={() => {
                      setHighlightAreas(!highlightAreas);
                    }}
                  />
                </Tooltip>
                <Tooltip text="Simulate Margins">
                  <BubbleButton
                    variant={variant}
                    appearance="squared"
                    className={`h-full${
                      !simulateMargins
                        ? ` border-b-4 border-${variant}-darker`
                        : ` border-b-2 bg-${variant}-lighter-i border-${variant}-darker`
                    }`}
                    icon="border-outer"
                    onClick={() => {
                      setSimulateMargins(!simulateMargins);
                    }}
                  />
                </Tooltip>
                {/* <Tooltip text="Show Archived">
                  <BubbleButton
                    variant={variant}
                    appearance="squared"
                    className={`h-full${
                      !showArchived
                        ? ` border-b-4 border-${variant}-darker`
                        : ` border-b-2 bg-${variant}-lighter-i border-${variant}-darker`
                    }`}
                    icon="archive"
                    onClick={() => {
                      setShowArchived(!showArchived);
                    }}
                  />
                </Tooltip> */}
                <div className={`bg-${variant}-darker`} style={{ width: 1 }}></div>
                {languages.length > 0 && (
                  <Tooltip text="Language">
                    <div className="dropdown-inline-fix">
                      <Dropdown
                        alignTop
                        items={languageDropdownItems.map(s => ({
                          key: s.key,
                          element: s.englishLabel,
                        }))}
                        onSelect={itm =>
                          setSelectedLanguage(
                            languageDropdownItems.find(di => di.key === itm.key) as Language
                          )
                        }
                      >
                        {({ toggleRef, ...rest }) => (
                          <BubbleButton
                            className={`border-b-4 border-${variant}-darker`}
                            buttonRef={toggleRef}
                            {...rest}
                            variant={variant}
                            appearance="squared"
                          >
                            {selectedLanguage.key.toUpperCase()}
                          </BubbleButton>
                        )}
                      </Dropdown>
                    </div>
                  </Tooltip>
                )}
                <div className={`bg-${variant}-darker`} style={{ width: 1 }}></div>
                {!editorLocked && (
                  <>
                    <Tooltip text={`Line Height (${rundownFontSize})`}>
                      <div
                        className="grid grid-cols-3 items-stretch"
                        style={{ gridTemplateColumns: 'auto 1fr auto' }}
                      >
                        <BubbleButton
                          variant={variant}
                          appearance="squared"
                          icon="minus"
                          className={`border-b-4 border-${variant}-darker`}
                          onClick={() => {
                            const newRundownFontSize =
                              rundownFontSize - RUNDOWN_FONT_SIZE_INCREMENT;
                            if (newRundownFontSize <= getMinRundownFont(feedTemplate.property))
                              return;
                            setRundownFontSize(newRundownFontSize);
                            onFontSizeDecreased(newRundownFontSize, currentPage);
                            context.setRundownFontSize(newRundownFontSize);
                          }}
                        />
                        <div
                          className={`flex items-center justify-center text-white font-semibold 
                            bg-${variant} px-1 cursor-pointer border-b-4 border-${variant}-darker`}
                          onClick={() => {
                            setRundownFontSize(RUNDOWN_DEFAULT_FONT_SIZE);
                            onFontSizeDecreased(RUNDOWN_DEFAULT_FONT_SIZE, currentPage);
                            context.setRundownFontSize(RUNDOWN_DEFAULT_FONT_SIZE);
                          }}
                        >
                          <FontAwesomeIcon fixedWidth icon="line-height" />
                        </div>
                        <BubbleButton
                          variant={variant}
                          appearance="squared"
                          icon="plus"
                          className={`border-b-4 border-${variant}-darker`}
                          onClick={() => {
                            const newRundownFontSize =
                              rundownFontSize + RUNDOWN_FONT_SIZE_INCREMENT;
                            if (newRundownFontSize > getMaxRundownFont(feedTemplate.property))
                              return;
                            setRundownFontSize(newRundownFontSize);
                            onFontSizeIncreased(newRundownFontSize, currentPage);
                            context.setRundownFontSize(newRundownFontSize);
                          }}
                        />
                      </div>
                    </Tooltip>
                    <div className={`bg-${variant}-darker`} style={{ width: 1 }} />
                  </>
                )}
                <Tooltip text={`Zoom (${zoom})`}>
                  <div
                    className="grid grid-cols-3 items-stretch"
                    style={{ gridTemplateColumns: 'auto 1fr auto' }}
                  >
                    <BubbleButton
                      variant={variant}
                      appearance="squared"
                      icon="minus"
                      className={`border-b-4 border-${variant}-darker`}
                      onClick={() => {
                        setZoom(zoom - ZOOM_INCREMENT);
                      }}
                    />
                    <div
                      className={`flex items-center justify-center text-white font-semibold 
                        bg-${variant} px-1 cursor-pointer border-b-4 border-${variant}-darker`}
                      onClick={() => {
                        setZoom(10);
                      }}
                    >
                      <FontAwesomeIcon fixedWidth icon="magnifying-glass" />
                    </div>
                    <BubbleButton
                      variant={variant}
                      className={`rounded-left-0-i border-b-4 border-${variant}-darker`}
                      icon="plus"
                      onClick={() => {
                        setZoom(zoom + ZOOM_INCREMENT);
                      }}
                    />
                  </div>
                </Tooltip>
              </div>
            </div>
            <InteractiveFeed
              zoom={zoom}
              simulateMargins={simulateMargins}
              showMergedVars={previewVars}
              highlightAreas={highlightAreas}
              selectedLanguage={selectedLanguage}
              cssBundle={feedTemplate.cssBundle!}
              onElementChanged={handleElementChange}
              onAreaDeleted={handleAreaDelete}
              onElementCreated={handleElementCreation}
              onColumnCreated={handleLayoutComponentCreation}
              onRowCreated={handleLayoutComponentCreation}
              onRowMove={handleLayoutComponentMove}
              plan={editorInfo.plan}
              property={property}
              dimensions={feedTemplate.dimensions}
              page={currentPage}
              contentTemplates={getActiveContentTemplatesLegacy()}
              onContentChange={handleContentChange}
              dailyProgram={dailyProgram}
              venueTemplates={getActiveVenueTemplates()}
              dayStart={editorInfo.plan.dayStart}
              sailingDay={dayBundle ? bareSailingDay(dayBundle.day) : undefined}
              activeElement={activeElement}
              setActiveElement={setActiveElement}
              editorLocked={editorLocked}
              mcmKey={getPrintProgramMcmEndpoint(feedTemplate)}
            />
          </div>
        ) : (
          <BubbleOverlay loading className="w-full h-full" hideBg />
        )}
      </div>

      {dayBundle && showTemplateLinkForm && (
        <BubbleDrawer
          onClose={() => setShowTemplateLinkForm(false)}
          containerClassName="bg-eggshell"
        >
          <TemplateLinkForm
            mode="single"
            user={user}
            property={property}
            sailing={bare(dayBundle.sailing)}
            sailingDay={bareSailingDay(dayBundle.day)}
            onClose={() => setShowTemplateLinkForm(false)}
            onTemplateNameClick={(block: FragmentBlockSync) => {
              _props.history.push(resolveTemplateFeedPath(property._id, block.templateId));
            }}
            onUnlinkTemplateFragments={handleOnUnlinkTemplateFragments}
            onLinkTemplateFragments={handleOnFinishLinkTemplateFragments}
            onCreateTemplateClick={handleOnCreateTemplateFormClick}
          />
        </BubbleDrawer>
      )}
      {showCreateTemplateForm && (
        <Popup title="Create a Template from Day" onClose={() => setShowCreateTemplateForm(false)}>
          {createTemplateForm && (
            <>
              <hr />
              <div className="p-4" style={{ width: '500px' }}>
                <div className="p-3 mb-3 bg-eggshell shadow rounded border">
                  Creating a template from:{' '}
                  <span className="font-bold">
                    {createTemplateForm.sailing.name} (Day {createTemplateForm.sailingDay.name})
                  </span>
                </div>
                <TemplateForm
                  submitButtonTitle="Create Template"
                  initialForm={createTemplateForm.templateData}
                  propertyTags={property.tags}
                  onSubmit={handleOnCreateTemplateFromSailingDay}
                  onUpdatePropertyTags={async propertyTags => {
                    await updateTags(property._id, propertyTags);
                    await refreshActiveProperty();
                  }}
                />
              </div>
            </>
          )}
        </Popup>
      )}
      {showTemplateViewForm && (
        <BubbleDrawer
          onClose={() => setShowTemplateViewForm(false)}
          containerClassName="bg-eggshell"
        >
          {editorInfo?.template && (
            <div className="p-8">
              <div className="flex items-start mb-2">
                <div>
                  <h1 className="text-xl text-slate-dark">Future Days Linked to Template</h1>
                </div>
                <BubbleButton
                  onClick={() => setShowTemplateViewForm(false)}
                  className="ml-auto -mt-3"
                  variant="navy"
                  inverse
                  icon="xmark-large"
                  iconSize="xl"
                />
              </div>
              <TemplateAssociations
                template={populateDayTemplate(editorInfo.template, editorInfo.plan.property)}
                onSailingDayNameClick={onSailingDayNameClick}
              />
            </div>
          )}
        </BubbleDrawer>
      )}
      {context.selectedContent && (
        <BubbleDrawer
          onClose={() => context.setSelectedContent(undefined)}
          containerClassName="bg-eggshell"
        >
          <BubbleDrawerBasicContainer
            title={`${context.selectedContent.type === 'edit' ? 'Edit' : 'Create'} Content`}
            subtitle="Content Details"
            onClose={() => context.setSelectedContent(undefined)}
          >
            <ContentTemplateFormik
              mode={context.selectedContent}
              onSubmit={() => {
                setSkipPageLoad(true);
                needsRefresh();
                if (context.selectedContent!.type != 'edit') {
                  context.setSelectedContent(undefined);
                }
              }}
              actionsAppearance="drawer-float"
              subnavClassName="-mx-8"
            />
          </BubbleDrawerBasicContainer>
        </BubbleDrawer>
      )}
      {contentFormMode && editorInfo && (
        <Popup hideHeader onClose={() => {}} position="full">
          <hr />
          <div style={{ width: '1000px' }}>
            <CanvasContentForm
              plan={editorInfo.plan}
              mode={contentFormMode}
              contentTemplates={original.contentTemplates.filter(c => !c.archived)}
              venueTemplates={original.venueTemplates.filter(v => !v.archived)}
              contentTemplateTranslations={translations.contentTemplateTranslations}
              onCreateTemplate={() => {
                needsRefresh();
              }}
              onClose={() => setContentFormMode(undefined)}
              onSubmitContent={handleContentFormSubmit}
              onRemoveContent={id => {
                handleContentDelete(id);
                setContentFormMode(undefined);
                needsRefresh(true);
              }}
            />
          </div>
        </Popup>
      )}
      {eventFormMode && editorInfo && (
        <Popup hideHeader onClose={() => setEventFormMode(undefined)} position="full">
          <hr />
          <div style={{ width: '1000px' }}>
            <CanvasEventForm
              mode={eventFormMode}
              plan={editorInfo.plan}
              onCreateTemplate={() => {
                needsRefresh();
              }}
              eventTemplateTranslations={translations.eventTemplateTranslations}
              venueTemplates={original.venueTemplates}
              eventTemplates={original.eventTemplates}
              staffTemplates={original.staffTemplates}
              onClose={() => setEventFormMode(undefined)}
              onSubmitEvent={handleEventFormSubmit}
              onRemoveEvent={handleEventDelete}
            />
          </div>
        </Popup>
      )}
    </div>
  );
}

function findAreaParent(page: FeedPage, areaId: string) {
  let match: FeedArea | undefined;
  page.areas.forEach(area => {
    if (area._id === areaId && !match) match = undefined;
    if (!match) {
      const matchedArea = findAreaRecursively(area, areaId, true);
      if (matchedArea) match = matchedArea;
    }
  });
  return match;
}

function findArea(
  page: FeedPage,
  areaId: string,
  outputParent: boolean = false
): FeedArea | undefined {
  let match: any;
  page.areas.forEach(area => {
    if (area._id === areaId && !match) match = area;
    if (!match) {
      const matchedArea = findAreaRecursively(area, areaId, outputParent);
      if (matchedArea) match = matchedArea;
    }
  });

  return match;
}

function findAreaRecursively(area: FeedArea, areaIdToMatch: string, outputParent: boolean) {
  return outputParent
    ? findParentAreaRecursively(area, areaIdToMatch)
    : findSingleAreaRecursively(area, areaIdToMatch);
}

function findSingleAreaRecursively(root: FeedArea, targetId: string): FeedArea | undefined {
  if (root._id === targetId) return root;
  if (!root.children) return;
  for (let child of root.children) {
    let match = findSingleAreaRecursively(child, targetId);
    if (match) return match;
  }
}

function findParentAreaRecursively(
  root: FeedArea,
  targetId: string,
  parent?: FeedArea
): FeedArea | undefined {
  if (root._id === targetId) return parent;
  if (!root.children) return;
  for (let child of root.children) {
    let match = findParentAreaRecursively(child, targetId, root);
    if (match) return match;
  }
}

function washIds(area: FeedArea) {
  area._id = new ObjectId().toHexString();
  (area.children || []).forEach(washIds);
}

function upsertCustomStyleElement(customAreasCss: string = '') {
  const styleId = 'customAreasCss';
  let style = document.getElementById(styleId);

  if (!style) {
    style = document.createElement('style');
    style.setAttribute('id', styleId);
  }

  style.innerHTML = customAreasCss;
  document.head.appendChild(style);
}

function upsertFontsElement(fonts: FeedEditorFont[] = []) {
  const styleId = 'customFonts';
  let style = document.getElementById(styleId);
  const customFontsCss = fonts.map(customFontsMap).join('\n');

  if (!style) {
    style = document.createElement('style');
    style.setAttribute('id', styleId);
  }

  style.innerHTML = customFontsCss;
  document.head.appendChild(style);
}

function customFontsMap(font: FeedEditorFont) {
  const location = `${Config.PUBLIC_ASSETS_URL}/fonts/${font.file}`;

  return `@font-face {
font-family: "${font.name}";
src: url(${location});
}
`;
}
